import { Search, Mic } from "lucide-react";

export const GoogleMock = () => (
  <div data-testid="google-mock" className="mt-6 overflow-hidden rounded-3xl border border-[var(--line)] bg-white shadow-[0_20px_50px_-30px_rgba(0,0,0,.35)]">
    <div className="flex items-center gap-4 border-b border-[var(--line)] px-5 py-4">
      <span className="hidden text-2xl font-bold sm:block" style={{ fontFamily: "Arial, sans-serif" }}>
        <span style={{ color: "#4285F4" }}>G</span><span style={{ color: "#EA4335" }}>o</span><span style={{ color: "#FBBC05" }}>o</span><span style={{ color: "#4285F4" }}>g</span><span style={{ color: "#34A853" }}>l</span><span style={{ color: "#EA4335" }}>e</span>
      </span>
      <div className="flex flex-1 items-center gap-3 rounded-full border border-[#dfe1e5] px-4 py-2.5 shadow-sm">
        <Search size={16} className="text-[#9aa0a6]" />
        <span className="flex-1 truncate text-sm text-[#202124]">名人堂 住房專案 優惠</span>
        <Mic size={16} className="text-[#4285F4]" />
      </div>
    </div>
    <div className="space-y-6 px-5 py-6 md:px-8" style={{ fontFamily: "Arial, 'Noto Sans TC', sans-serif" }}>
      <div data-testid="google-mock-result" className="relative rounded-2xl bg-[#FFF4EC] p-4 ring-2 ring-[var(--orange-2)]">
        <span className="absolute -top-3 right-4 rounded-full bg-[var(--orange)] px-3 py-0.5 text-xs font-bold text-white">人客多專案頁</span>
        <div className="flex items-center gap-3">
          <span className="grid h-7 w-7 place-items-center rounded-full bg-white text-xs font-black text-[var(--orange)]">名</span>
          <div className="leading-tight">
            <p className="text-sm text-[#202124]">名人堂花園大飯店</p>
            <p className="text-xs text-[#4d5156]">https://hotel.fhgh.com.tw › 人客多專案</p>
          </div>
        </div>
        <p className="mt-2 text-lg text-[#1a0dab] md:text-xl">人客多特惠專案｜名人堂花園大飯店 5 種房型・雙人一泊一食 NT$3,500 起</p>
        <p className="mt-1 text-sm text-[#4d5156]">網紅親子住房、退休族樂活平日專案。史努比主題房、DIY 課程、KTV 歡唱、高鐵接駁…</p>
      </div>
      {[0, 1].map((i) => (
        <div key={i} className="space-y-2 opacity-50">
          <div className="h-3 w-40 rounded bg-[#e8eaed]" />
          <div className="h-4 w-3/4 rounded bg-[#d2e3fc]" />
          <div className="h-3 w-full rounded bg-[#f1f3f4]" />
        </div>
      ))}
    </div>
  </div>
);
